<template>
  <div class="diy-search-box dis-flex col-f ts-3">
    <div :class="'diy-search flex-box angle-'+itemStyle.searchStyle+' text-'+itemStyle.textAlign">
      <div class="cont" url="/pages/search/index">
        <span class="iconfont icon-sousuo f-30"></span>
        <span class="f-28">{{ params.placeholder }}</span>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params"],
  created(){
  },
  activated() {
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
.diy-search-box {
  position: unset;
  background: #f1f1f2;
  padding: 10px 12px;
  color: #fff;
  -moz-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.diy-search-box .diy-search {
  width: 90%;
  border-bottom: 0;
  background: #fff;
  overflow: hidden;
  position: relative;
  color: #fff;
  box-sizing: border-box;
  margin: 0 auto;
  padding: 0 10px;
  line-height: 30px;
  border-radius: unset;
  font-size: 14px;
}

.diy-search-box .diy-search .cont .icon-sousuo {
  margin-right: 5px;
}

.diy-search-box span {
  color: #999;
}

/* 输入框四角风格 */

.diy-search-box .diy-search.angle-radius {
  border-radius: 5px;
}

.diy-search-box .diy-search.angle-round {
  border-radius: 40px;
}

/* 文字对齐 */

.diy-search-box .diy-search.text-center {
  text-align: center;
}

.diy-search-box .diy-search.text-right {
  text-align: right;
}
</style>